<template>
  <div class="d-flex align-start" style="padding: 10px;">
    <div style="position: relative; width: 200px; height: 100px; padding: 4px; margin-right: 16px;">
      <span class="favorite" :id="'fav-' + company.id">
          <Heart @click="handleUnFavorite(company.id)" color="#ee2424" :size="22" fill="#ee2424" v-if="isFavorite"/>
          <Heart @click="handleFavorite(company.id)" color="#313131" :size="22" v-else />
        </span>
      <v-img :src="this.company.logo_empresa" :alt="`Logo de ${company.nome_fantasia_empresa}`" cover
        style="border-radius: 4px;" width="200" height="100" />
      <div @click="videoDialog = true" class="video-overlay-button" v-show="this.company.video">
        <v-icon small class="mr-1">mdi-play-circle</v-icon>
        VÍDEO
      </div>

    </div>

    <div>
      <div class="anunciante-grupo">
        <small class="text-subtitle-2 mb-1 text-white">Grupo</small>
        <strong class="anunciante-logo">{{ company.nome_fantasia_empresa.toUpperCase() }}</strong>
      </div>
      <div v-if="rating !== '0' && rating !== undefined" class="d-flex align-center mb-2" style="cursor: pointer;"
        @click="toggleDropdown">
        <v-rating :model-value="rating" half-increments readonly color="amber" bg-color="grey-lighten-2"
          density="compact" class="mr-2" />
        <span class="mr-1 font-weight-medium text-amber font-bold">{{ rating }}</span>
        <v-icon size="18" class="text-amber font-bold">
          {{ showDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>

      <div v-if="showDetails">
        <v-row dense no-gutters class="flex-column">
          <v-col
            v-for="(item, index) in detalhes"
            :key="index"
            class="d-flex align-center"
          >
          <div>
            <v-rating
              :model-value="item.score"
              half-increments
              readonly
              color="grey-darken-1"
              bg-color="grey-darken-1"
              density="compact"
              size="18"
              class="me-2"
            />
          </div>
          <div>
            <span class="text-body-2 text-grey-darken-1 font-weight-regular mr-1">
              {{ item.score }}
            </span>
          </div>
          <div>
            <span class="text-body-2 text-grey-darken-1 font-weight-regular mr-1">
              {{ item.detail }}
            </span>
          </div>
          </v-col>

          <v-col class="pt-2">
            <span class="text-caption text-grey-lighten-1">
              ({{ reviews }} reviews de {{ clientes }} clientes)
            </span>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>

  <v-dialog v-if="company.video" v-model="videoDialog" max-width="900px" persistent scrollable
    :scrim="'rgba(0, 0, 0, 0.85)'">
    <v-card class="bg-black pa-0">
      <v-card-text class="pa-0">
        <iframe :src="youtubeEmbedUrl" width="100%" height="500" frameborder="0" allowfullscreen></iframe>
      </v-card-text>
    </v-card>

    <v-btn icon class="video-close-btn" @click="videoDialog = false">
      <v-icon size="32" color="white">mdi-close</v-icon>
    </v-btn>
  </v-dialog>
</template>

<script>
import {
  favoriteDealer,
  unFavoriteDealer
} from "@/services/api/DealerServiceApi";

import { Heart } from "lucide-vue-next";
import { mapActions, mapState } from "vuex";

export default {
  props: ['company'],
  components: {
    Heart,
  },
  data() {
    return {
      showDetails: false,
      rating: this.company.nota_reviews,
      videoDialog: false,
      isFavorite: false,
      dealers: null
    };
  },
  methods: {
    ...mapActions("dealer", ["getDealersData"]),
    toggleDropdown() {
      this.showDetails = !this.showDetails;
    },
    async handleFavorite(id) {
      this.isFavorite = true;
      try {
        await favoriteDealer(id)
      } catch (error) {
        this.isFavorite = false
      }
    },
    async handleUnFavorite(id) {
      this.isFavorite = false;
      try {
        await unFavoriteDealer(id)
      } catch (error) {
        this.isFavorite = true
      }
    }
  },
  computed: {
    ...mapState({
      detalhes: state => state.advertiser.list?.company?.details_reviews || [],
      reviews: state => state.advertiser.list?.company?.total_reviews || 0,
      clientes: state => state.advertiser.list?.company?.total_customers_reviews || 0
    }),
    youtubeEmbedUrl() {
      try {
        const url = new URL(this.company.video);
        const videoId = url.searchParams.get('v') || url.pathname.split('/').pop();
        return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : '';
      } catch {
        return '';
      }
    },
  },
  async mounted(){
    this.dealers = await this.getDealersData();
    this.dealers = this.dealers.filter(el => el.id_empresa == this.company.id)
    this.isFavorite = (this.dealers[0].favorita == 1);
  }
};
</script>

<style scoped>
.favorite {
  position: absolute;
  top: 10px;
  left: 15px;
  cursor: pointer;
  z-index: 999;

}

.anunciante-grupo{
  display: flex;
  flex-direction: column;
}
.anunciante-logo {
  color: white;
  font-size: 34px;
  font-weight: 400;
  font-family: "Roboto", Roboto, Helvetica, sans-serif;
  text-shadow: 0 2px 7px #000;
  line-height: 24px;
  font-weight: bold;
}

.video-overlay-button {
  position: absolute;
  bottom: 4px;
  left: 4px;
  background-color: red;
  color: white;
  font-weight: bold;
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}

.video-close-btn {
  position: fixed;
  top: 20px;
  right: 30px;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
